import RoomElement from './room_element';

export default RoomElement;
